import { CatalogArtworkRepository } from '@lib/api/repository/catalog-artwork/catalog-artwork.repository';

export default class CatalogArtworkService {
  constructor(private repository: CatalogArtworkRepository) {}

  exportArtworkManifest(signal?: AbortSignal) {
    return this.repository.exportArtworkManifest(signal);
  }

  importArtworkManifest(file: File) {
    return this.repository.importArtworkManifest(file);
  }

  listArtworks(cardId: string, collectionId?: string, signal?: AbortSignal) {
    return this.repository.listArtworks(cardId, collectionId, signal);
  }

  setArtworkExternalReference(cardId: string, externalId: string) {
    return this.repository.setArtworkExternalReference(cardId, externalId);
  }

  synchronizeArtworks(cardId: string) {
    return this.repository.synchronizeArtworks(cardId);
  }

  uploadArtwork(cardId: string, file: File, isPrimary?: boolean) {
    return this.repository.uploadArtwork(cardId, file, isPrimary);
  }

  setPrimaryArtwork(cardId: string, artworkId: string) {
    return this.repository.setPrimaryArtwork(cardId, artworkId);
  }

  setArtworkEnabled(cardId: string, artworkId: string, enabled: boolean) {
    return this.repository.setArtworkEnabled(cardId, artworkId, enabled);
  }

  deleteArtwork(cardId: string, artworkId: string) {
    return this.repository.deleteArtwork(cardId, artworkId);
  }

  setPrintingArtwork(
    cardId: string,
    printingId: string,
    options: {
      artworkId?: string | null;
      rarityId?: string;
      code?: string;
      isAlternateArt?: boolean;
    },
  ) {
    return this.repository.setPrintingArtwork(cardId, printingId, options);
  }

  createPrinting(
    cardId: string,
    data: {
      collectionId: string;
      rarityId: string;
      code: string;
      isAlternateArt?: boolean;
      artworkId?: string | null;
    },
  ) {
    return this.repository.createPrinting(cardId, data);
  }

  deletePrinting(cardId: string, printingId: string) {
    return this.repository.deletePrinting(cardId, printingId);
  }

  reorderPrintings(cardId: string, printingIds: string[]) {
    return this.repository.reorderPrintings(cardId, printingIds);
  }
}
